// Shared react-query fetchers/keys for homepage (and site-wide) data.
//
// Using the same query key from multiple components is what makes
// deduplication work: react-query collapses simultaneous calls to
// useQuery({ queryKey: homeQueryKey, ... }) from Hero, BenefitMarquee,
// ShopByCategory, ProductTabs and Storytelling into a single network
// request, and caches the result (see the QueryClient's staleTime in
// index.js) so remounts/navigations don't refetch needlessly.
import { api } from "@/lib/api";

export const homeQueryKey = ["home"];
export const fetchHome = () => api.get("/home").then((r) => r.data);

export const settingsQueryKey = ["settings"];
export const fetchSettings = () => api.get("/content/settings").then((r) => r.data);

export const productsByTagQueryKey = (tag) => ["products", "tag", tag];
export const fetchProductsByTag = (tag) => api.get(`/products?tag=${tag}&limit=8`).then((r) => r.data.items);
